import React, { useContext, useEffect, useState } from "react";
import { Button, Checkbox, FileUploader, IconInput, Input, RsDatePicker, Select, TagsInputs, UserNameInput } from "../../Components";
// import { _getNumberToCurrency, getFullName } from "../../Helpers/Functions";
import { GroupRadios } from "../../Components/GroupRadios";
import * as Yup from 'yup';
import { FILE_SIZES, validationSchema } from "./validations";
import { useApi } from "../../Helpers/ApiHook";
import moment from "moment";
import { getFullName } from "../../Helpers/Functions";
import { AuthContext } from "../../Contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { TitleSection } from "../GymFacilities/components";
import REGEX from "../../Constants/Regex";
import { Switch } from "../../Components";
import CustomAlert from "../../Components/CustomAlert";

const SERVICES_DEFAULT_STATE = { img: "", title: '', price: '' };
const YOUTUBE_LINKS_DEFAULT_STATE = { title: '', channel: "Youtube", link: "" };

const DEFAULT_VALUES = {
    first_name: '',
    last_name: '',
    user_name: "",
    email: '',
    phone_no: '',
    whatsapp_no: '',
    dob: '',
    gender: 'Male',
    city_id: '',
    state_id: '',
    country_id: '',
    pincode: '',
    full_address: '',
    designation: '',
    workplace_name: '',
    experience_yrs: '',
    languages: [],
    instagram: '',
    facebook: '',
    youtube: '',
    linkedin: '',
    tagline: '',
    about_description: '',
    clients_coached: '',
    availability: 'Online/Offline',
    qualification: "",
    certification_tags: [],
    specialization_tags: [],
    codeOfEthics: false,
    digital_signature: '',
    services: [SERVICES_DEFAULT_STATE],
    youtube_links: [YOUTUBE_LINKS_DEFAULT_STATE],
}

const GENDER_OPTIONS = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Other', label: 'Other' }
];

const CreateTrainer = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const { getUserDetails, user } = useContext(AuthContext);

    const isMyProfilePage = location.pathname === '/my-profile';
    const user_id = user?.trainer_details?.id || null;

    const { get, postFormData } = useApi();

    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingState, setIsLoadingState] = useState(false)
    const [isLoadingCities, setIsLoadingCities] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [formData, setFormData] = useState(DEFAULT_VALUES);
    const [countries, setCountries] = useState([])
    const [stateList, setStateList] = useState([])
    const [cities, setCities] = useState([]);

    const [designationList, setDesignationList] = useState([])
    const [categories, setCategories] = useState([])

    const [errors, setErrors] = useState({});

    const [isValidUserName, setValidUserName] = useState(false);


    const _getTrainerDetails = async () => {
        setIsLoading(true);
        try {
            const data = await get(`trainers/show/${user_id}`);
            if (data?.status) {
                setFormData({
                    ...DEFAULT_VALUES,
                    ...data?.data,
                    ...data?.data?.social_links,
                    ...data?.data?.location,
                    documents: { ...data?.data?.documents, profile_img: data?.data?.profile_img, banner_img: data?.data?.banner_img },
                    profile_img: "",
                    banner_img: "",
                    codeOfEthics: true,
                    user_name: data?.data?.user_name || ""
                });

                if (!!data?.data?.user_name) {
                    setValidUserName(true);
                }
            }
        } catch (error) {
            console.error("Error fetching trainers: ", error);
        } finally {

        }
    };

    useEffect(() => {
        if (isMyProfilePage) {
            _getTrainerDetails();
        }
        _getDesignations();
        _getCategories();
        _getCountry();
    }, [])

    useEffect(() => {
        if (!!formData.country_id) {
            _getState()
        } else {
            setStateList([])
        }
    }, [formData.country_id])

    useEffect(() => {
        if (!!formData.country_id && !!formData?.state_id) {
            _getCities()
        } else {
            setCities([])
        }
    }, [formData?.state_id])

    const _getDesignations = async () => {
        await setIsLoading(true);
        await get("designations")
            .then((data) => {
                if (data.status) {
                    setDesignationList(data?.data || []);
                }
            }).catch((error) => {
                console.error("Error fetching _getDesignations: ", error);
            }).finally(() => {
                // setIsLoading(false);
            });
    }

    const _getCategories = async () => {
        await setIsLoading(true);
        await get("trainer-categories", {
            params: {

            }
        }).then((data) => {
            // console.log("🚀 ~ _getState ~ data?.data:", data)
            if (data.status) {
                setCategories(data?.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching _getCategories: ", error);
        }).finally(() => {
            // setIsLoading(false);
        });
    }

    const _getCountry = async () => {
        await setIsLoading(true);
        await get("countries/list", {
            params: {

            }
        }).then((data) => {
            // console.log("🚀 ~ _getState ~ data?.data:", data)
            if (data.status) {
                setCountries(data?.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching trainers: ", error);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const _getState = async () => {
        await setIsLoadingState(true);
        await get(`states/${formData.country_id}`, {
        }).then((data) => {
            // console.log("🚀 ~ _getState ~ data?.data:", data)
            if (data.status) {
                setStateList(data?.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching trainers: ", error);
        }).finally(() => {
            setIsLoadingState(false);
        });
    }

    const _getCities = async () => {
        await setIsLoadingCities(true);
        await get(`cities/${formData?.state_id}`, {
        }).then((data) => {
            // console.log("🚀 ~ _getState ~ data?.data:", data)
            if (data.status) {
                setCities(data?.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching trainers: ", error);
        }).finally(() => {
            setIsLoadingCities(false);
        });
    }


    const handleChange = (e, regex = null) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : !!regex ? (value || "").replace(regex, "") : value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleTagChange = (keyName, tags) => {
        setFormData(prev => ({
            ...prev,
            [keyName]: tags
        }));
    };

    const validateField = async (fieldName, value) => {
        try {
            await validationSchema.validateAt(fieldName, { [fieldName]: value });
            setErrors(prev => ({ ...prev, [fieldName]: '' }));
        } catch (err) {
            setErrors(prev => ({ ...prev, [fieldName]: err.message }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await setIsSubmitting(true)
        try {
            // console.log(formData)
            await validationSchema.validate(formData, { abortEarly: false });
            // console.log('Form Data:', formData);
            await setErrors({});
            await onSubmitTrainerDetails();
            // alert('Form submitted successfully!');
            // Handle form submission here
        } catch (err) {
            const validationErrors = {};
            err.inner.forEach(error => {
                validationErrors[error.path] = error.message;
            });
            // console.log(validationErrors)
            setErrors(validationErrors);
            setIsSubmitting(false)
        }
    };

    const onSubmitTrainerDetails = async () => {
        try {

            const trainerFormData = new FormData();

            Object.entries({ ...formData }).forEach(([key, value]) => {

                const appendValue = (path = "", val = "") => {
                    if (val instanceof File || val instanceof Blob) {
                        trainerFormData.append(path, val, val.name); // ✅ use filename here
                    } else if (typeof val === "object" && val !== null) {
                        trainerFormData.append(path, JSON.stringify(val));
                    } else {
                        trainerFormData.append(path, "" + (val ?? ""));
                    }
                };

                const objectAppend = (path = "", val = {}) => {
                    if (val instanceof File || val instanceof Blob) {
                        appendValue(`${path}`, val || null);
                    } else {
                        Object.entries({ ...val }).forEach(([subKey, subVal]) => {
                            appendValue(`${path}[${subKey}]`, subVal || "");
                        });
                    }
                }

                if (Array.isArray(value)) {
                    value.forEach((item, i) => {
                        if (typeof item === 'object') {
                            objectAppend(`${key}[${i}]`, item)
                        } else {
                            appendValue(`${key}[${i}]`, item);
                        }
                    });
                } else if (typeof value === 'object' && value !== null) {
                    objectAppend(`${key}`, value || "")
                } else {
                    appendValue(key, value);
                }
            });
            trainerFormData.append('full_name', getFullName({ first_name: formData?.first_name, last_name: formData.last_name }))

            const urlPath = (isMyProfilePage ? `trainers/update/${user_id}` : "trainers/add");
            const response = await postFormData(urlPath, trainerFormData)
            // console.log("response =>", response)
            if (!!response?.status) {
                if (isMyProfilePage) {
                    CustomAlert({
                        type: "success",
                        title: "My Profile Update",
                        message: 'Trainer profile successfully updated.',
                        confirmText: 'Okay',
                        onConfirm: (e) => {
                            onUpdateLocalData()
                        }
                    })
                } else {
                    CustomAlert({
                        type: "success",
                        title: "FWPI Membership Form Create",
                        message: 'FWPI Membership form successfully created',
                        confirmText: 'Okay',
                        onConfirm: (e) => {
                            onUpdateLocalData()
                        }
                    })
                }
            }
        } catch (e) {
            // console.log(e)
        } finally {
            setIsSubmitting(false)
        }
    }

    const onUpdateLocalData = async () => {
        await navigate(-1);
        await getUserDetails()
    }


    const handleReset = () => {
        setFormData(DEFAULT_VALUES);
        setErrors({});
    };

    const addService = () => {
        setFormData(prev => ({
            ...prev,
            services: [...prev.services, SERVICES_DEFAULT_STATE]
        }));
    };

    const removeService = (index) => {
        setFormData(prev => ({
            ...prev,
            services: prev.services.filter((_, i) => i !== index)
        }));
    };

    const handleServiceChange = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            services: prev.services.map((service, i) =>
                i === index ? { ...service, [field]: value } : service
            )
        }));
    };


    const addYoutubeLink = () => {
        setFormData(prev => ({
            ...prev,
            youtube_links: [...prev.youtube_links, YOUTUBE_LINKS_DEFAULT_STATE]
        }));
    };

    const removeYoutubeLink = (index) => {
        setFormData(prev => ({
            ...prev,
            youtube_links: prev.youtube_links.filter((_, i) => i !== index)
        }));
    };

    const handleYoutubeChange = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            youtube_links: prev.youtube_links.map((link_details, i) =>
                i === index ? { ...link_details, [field]: value } : link_details
            )
        }));
    };

    return (
        <div className="w-full bg-gradient-radial flex flex-col">

            <TitleSection
                title="FWPI Membership Form"
                subtitle="Join India’s Premier Network of Certified Fitness & Wellness Professional. Kindly complete the form below to apply for Professional Membership with the Fitness & Wellness Professionals of India (FWPI) — uniting & uplifting the India's fitness and wellness industry."
            />
            {/* <section className="w-full bg-gradient-radial lg:pt-20 pt-20 pb-12 lg:py-28">
                <div className="w-full lg:w-full flex flex-col items-center py-12">
                    <img className="md:w-[25rem] w-[15rem] h-auto" src="/assets/FWPI-logo.png" alt="FWPI Logo About Us" />
                </div>

                <div className='w-full flex flex-col justify-between items-center'>
                    <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center mb-8 lg:mb-12">
                        FWPI Membership Form
                    </h2>
                    <p className='mt-2 text-md text-center text-white px-4 lg:px-48 font-urbanist'>
                        Join India’s Premier Network of Certified Fitness & Wellness Professional. Kindly complete the form below to apply for Professional Membership with the Fitness & Wellness Professionals of India (FWPI) — uniting & uplifting the India's fitness and wellness industry.
                    </p>
                </div>
            </section> */}
            <div className='w-full bg-gradient-radial'>
                <div className="container mx-auto px-4 lg:px-10">
                    {
                        isLoading ?
                            <div className="max-w-6xl font-urbanist rounded-lg mx-auto space-y-8 bg-[#181B23] text-white py-12 px-12 lg:px-32" >
                                <div className="w-full flex justify-center items-center">
                                    <span
                                        className="inline-block w-10 h-10 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mr-2"
                                    ></span>
                                </div>
                            </div>
                            :
                            <div className="max-w-6xl font-urbanist rounded-lg mx-auto space-y-8 bg-[#181B23] text-white py-6 px-6 md:px-12 lg:px-32" >
                                {/* Row 1: Full Name */}
                                {
                                    isMyProfilePage &&
                                    <div className="flex flex-row justify-end">
                                        <Switch
                                            size="md"
                                            label="Availability"
                                            checked={formData?.availability === "Online" || formData?.availability === "Online/Offline"}
                                            onChange={(isCheck) => {
                                                setFormData((prevState) => ({ ...prevState, availability: isCheck ? 'Online/Offline' : 'Offline' }))
                                            }}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                }
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                                    <Input
                                        label="First Name"
                                        id="first_name"
                                        name="first_name"
                                        value={formData.first_name}
                                        placeholder="Enter Your First Name"
                                        onChange={handleChange}
                                        errors={errors}
                                        required
                                        disabled={isSubmitting}
                                    />
                                    <Input
                                        label="Last Name"
                                        id="last_name"
                                        name="last_name"
                                        value={formData.last_name}
                                        onChange={handleChange}
                                        errors={errors}
                                        placeholder="Enter Your Last Name"
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>

                                <UserNameInput
                                    user_id={user_id || null}
                                    category="trainer"
                                    value={formData.user_name}
                                    onChange={(e) => { handleChange(e, REGEX.USER_NAME_REGEX) }}
                                    errors={errors}
                                    required={true}
                                    disabled={isSubmitting}
                                    onStatusChange={({ status, isExist, username }) => {
                                        // console.log("status", status, "isExist", isExist, "username", username);
                                        if (isExist === true) {
                                            setValidUserName(true);
                                        } else {
                                            setValidUserName(false);
                                        }
                                        // isExist === true  => username exists (taken)
                                        // isExist === false => username available
                                        // isExist === null  => other states (tooShort, checking, invalid, error, idle)
                                    }}
                                />

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                                    <RsDatePicker
                                        format='dd/MM/yyyy'
                                        label="Date of Birth"
                                        id="dob"
                                        name="dob"
                                        disableFutureDates={true}
                                        value={!!formData.dob ? moment(formData.dob, "YYYY/MM/DD").toDate() : null}
                                        onChange={(date) => { handleTagChange('dob', moment(date).format("YYYY/MM/DD")) }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                        required
                                    />

                                    <GroupRadios
                                        label="Gender"
                                        required={true}
                                        name={'gender'}
                                        value={formData?.gender}
                                        onChange={handleChange}
                                        errors={errors}
                                        options={GENDER_OPTIONS}
                                        disabled={isSubmitting}
                                    />

                                    <Input
                                        label="Email Address"
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formData?.email}
                                        onChange={handleChange}
                                        errors={errors}
                                        placeholder="Enter Your Email Address"
                                        required
                                    />

                                    <IconInput
                                        src="https://flagcdn.com/in.svg"
                                        label="Contact Number"
                                        id="phone_no"
                                        name="phone_no"
                                        type="tel"
                                        value={formData?.phone_no}
                                        onChange={(e) => handleChange(e, /[^0-9]/, "")}
                                        errors={errors}
                                        placeholder="0000000000"
                                        maxLength={10}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    <Select
                                        label="Designation"
                                        id="designation"
                                        name="designation"
                                        placeholder="Enter Your Designation"
                                        onChange={handleChange}
                                        options={designationList}
                                        schema={{ name: "name", value: "name" }}
                                        errors={errors}
                                        value={formData.designation}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    <IconInput
                                        src="https://flagcdn.com/in.svg"
                                        label="WhatsApp Number"
                                        id="whatsapp_no"
                                        name="whatsapp_no"
                                        value={formData?.whatsapp_no}
                                        onChange={(e) => handleChange(e, /[^0-9]/, "")}
                                        errors={errors}
                                        type="tel"
                                        placeholder="0000000000"
                                        maxLength={10}
                                        required
                                        disabled={isSubmitting}
                                    />

                                </div>

                                <div className="w-full flex flex-col justify-center gap-x-6 gap-y-6">
                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Address :-
                                    </p>

                                    {/* Full Address */}
                                    <Input
                                        type='textarea'
                                        label="Full Address"
                                        id="full_address"
                                        name="full_address"
                                        placeholder="Enter Your Address"
                                        onChange={handleChange}
                                        errors={errors}
                                        value={formData?.full_address}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    {/* Row 4: City and State */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">

                                        <Select
                                            label="Country"
                                            id="country_id"
                                            name="country_id"
                                            placeholder="Enter Your Country"
                                            onChange={handleChange}
                                            options={countries}
                                            schema={{
                                                name: "name",
                                                value: "id"
                                            }}
                                            errors={errors}
                                            value={formData?.country_id}
                                            required
                                            disabled={isSubmitting}
                                        />

                                        <Select
                                            loading={isLoadingState}
                                            label="State"
                                            id="state_id"
                                            name="state_id"
                                            placeholder="Enter Your State"
                                            onChange={handleChange}
                                            options={stateList}
                                            schema={{
                                                name: "name",
                                                value: "id"
                                            }}
                                            errors={errors}
                                            value={formData?.state_id}
                                            required
                                            disabled={isSubmitting}
                                        />
                                        <Select
                                            loading={isLoadingCities}
                                            label="City"
                                            id="city_id"
                                            name="city_id"
                                            placeholder="Enter Your City"
                                            onChange={handleChange}
                                            options={cities}
                                            schema={{
                                                name: "name",
                                                value: "id"
                                            }}
                                            errors={errors}
                                            value={formData?.city_id}
                                            required
                                            disabled={isSubmitting}
                                        />
                                        <Input
                                            label="Pin Code"
                                            id="pincode"
                                            name="pincode"
                                            placeholder="Enter Your Pin Code"
                                            onChange={handleChange}
                                            errors={errors}
                                            value={formData?.pincode}
                                            required
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="w-full flex flex-col justify-center gap-x-6 gap-y-6">

                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Social Media Links :-
                                    </p>

                                    {/* Certifications and Instagram URL */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                                        <Input
                                            label="Instagram URL"
                                            id="instagram"
                                            name="instagram"
                                            type="url"
                                            placeholder="Enter Your Instagram URL"
                                            value={formData?.instagram}
                                            onChange={handleChange}
                                            errors={errors}
                                            disabled={isSubmitting}
                                        />
                                        <Input
                                            label="Facebook URL"
                                            id="facebook"
                                            name="facebook"
                                            type="url"
                                            placeholder="Enter Your Facebook URL"
                                            onChange={handleChange}
                                            errors={errors}
                                            value={formData?.facebook}
                                            disabled={isSubmitting}
                                        />
                                        <Input
                                            label="Youtube URL"
                                            id="youtube"
                                            name="youtube"
                                            type="url"
                                            placeholder="Enter Your Youtube URL"
                                            onChange={handleChange}
                                            errors={errors}
                                            value={formData?.youtube}
                                            disabled={isSubmitting}
                                        />
                                        <Input
                                            label="LinkedIn URL"
                                            id="linkedin"
                                            name="linkedin"
                                            type="url"
                                            placeholder="Enter Your LinkedIn URL"
                                            onChange={handleChange}
                                            errors={errors}
                                            value={formData?.linkedin}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="w-full flex flex-col justify-center gap-x-6 gap-y-6">

                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Professional Information :-
                                    </p>

                                    {/* About Us */}
                                    <Input
                                        label="Tagline for About Us"
                                        id="tagline"
                                        name="tagline"
                                        placeholder="Enter Your Tagline for About Us"
                                        value={formData?.tagline}
                                        onChange={handleChange}
                                        errors={errors}
                                        required
                                        disabled={isSubmitting}
                                    />
                                    <Input
                                        type='textarea'
                                        label="About You Description"
                                        id="about_description"
                                        name="about_description"
                                        placeholder="Enter Your About You Description"
                                        onChange={handleChange}
                                        errors={errors}
                                        value={formData?.about_description}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                                        <Input
                                            type="number"
                                            label="Experience Years"
                                            id="experience_yrs"
                                            name="experience_yrs"
                                            placeholder="Enter Your Experience Years"
                                            value={formData?.experience_yrs}
                                            onChange={handleChange}
                                            errors={errors}
                                            required
                                        />
                                        <Input
                                            type='number'
                                            label="Clients Coached"
                                            id="clients_coached"
                                            name="clients_coached"
                                            placeholder="Enter Your Clients Coached"
                                            onChange={handleChange}
                                            errors={errors}
                                            value={formData?.clients_coached}
                                            required
                                            disabled={isSubmitting}
                                        />
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">

                                        {/* Current Workplace */}
                                        <Input
                                            label="Current Workplace / Facility Name"
                                            id="workplace_name"
                                            name="workplace_name"
                                            value={formData?.workplace_name}
                                            onChange={handleChange}
                                            errors={errors}
                                            placeholder="Enter Your Current Workplace / Facility Name"
                                            disabled={isSubmitting}
                                        />
                                        <Input
                                            label="Navigation Url"
                                            id="navigation_url"
                                            name="navigation_url"
                                            value={formData?.navigation_url}
                                            onChange={handleChange}
                                            errors={errors}
                                            placeholder="Enter Your Navigation Url"
                                            disabled={isSubmitting}
                                        />
                                    </div>

                                    {/* Professional Qualification Category */}

                                    <Select
                                        label={`Please select the appropriate category that best represents your professional qualification to proceed with your FWPI Membership Application`}
                                        subTitle={`(e.g., Personal Trainer, Fitness Trainer, Strength & Conditioning Coach, Physiotherapist, Dance Instructor, Group Fitness Instructor, Pilates Instructor, Yoga Instructor, Nutrition Advisor, Clinical Nutrition Advisor, Wellness Coach, Health Coach, Gym Instructor, Sports Coach, Swimming Instructor, Aerobics Instructor, etc.,)`}
                                        id="qualification"
                                        name="qualification"
                                        placeholder="Enter Your Qualification Category"
                                        onChange={handleChange}
                                        options={categories}
                                        schema={{
                                            name: "name",
                                            value: "name"
                                        }}
                                        errors={errors}
                                        value={formData?.qualification}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    <TagsInputs
                                        label="Which Language You Known"
                                        subTitle={`(e.g. English, Hindi, Gujarati, Marathi, Tamil, etc.)`}
                                        id="languages"
                                        name="languages"
                                        placeholder="Add Your Which Language You Known..."
                                        value={formData.languages || []}
                                        onChange={(tags) => { handleTagChange('languages', tags); }}
                                        errors={errors}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    <TagsInputs
                                        label="Certifications / Courses Completed"
                                        subTitle={`(e.g. Certified Fitness Trainer, Strength & Conditioning Specialist, Functional Training Specialist, PCOD & PCOS Exercise Specialist, Nutrition & Weight Management etc.)`}
                                        id="certification_tags"
                                        name="certification_tags"
                                        placeholder="Add Your Certifications / Courses Completed..."
                                        value={formData.certification_tags || []}
                                        onChange={(tags) => { handleTagChange('certification_tags', tags); }}
                                        errors={errors}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    <TagsInputs
                                        label="Specializations"
                                        subTitle={`(e.g. Home Workout, Strength Training, Weight Training, HIIT, Functional Training, Nutrition, PCOD & PCOS etc.)`}
                                        id="specialization_tags"
                                        name="specialization_tags"
                                        placeholder="Add Your Certifications / Courses Completed..."
                                        value={formData.specialization_tags || []}
                                        onChange={(tags) => { handleTagChange('specialization_tags', tags); }}
                                        errors={errors}
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>

                                <div className="w-full flex flex-col justify-center  gap-x-6 gap-y-6">

                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Required Documents :-
                                    </p>

                                    {/* File Upload: Professional Photo */}
                                    <FileUploader
                                        id="profile_img"
                                        name="profile_img"
                                        label="Profile Image"
                                        uploadedImage={formData?.documents?.profile_img || null}
                                        accept='.png, .jpg, .jpeg'
                                        sizeInMb={FILE_SIZES.PROFILE_FILE_SIZE}
                                        required
                                        maxFiles={1}
                                        onChange={(event) => {
                                            handleTagChange('profile_img', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />

                                    <FileUploader
                                        id="banner_img"
                                        name="banner_img"
                                        label="Banner Image"
                                        accept='.png, .jpg, .jpeg'
                                        required
                                        uploadedImage={formData?.documents?.banner_img || null}
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.BANNER_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('banner_img', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />

                                    {/* File Upload: Aadhaar Card */}
                                    <FileUploader
                                        id="aadhar_card"
                                        name="aadhar_card"
                                        label="Submit Aadhaar Card as Proof of Identity"
                                        accept='.pdf'
                                        required
                                        uploadedImage={formData?.documents?.aadhar_card || null}
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.AADHAR_CARD_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('aadhar_card', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />

                                    {/* Educational Qualification Upload */}
                                    <FileUploader
                                        id="educational_certificate"
                                        name="educational_certificate"
                                        label="To better understand your profile, you must provide your educational qualification?"
                                        subTitle='(such as 10th, 12th, Graduation, Post Graduation)'
                                        accept='.pdf'
                                        uploadedImage={formData?.documents?.educational_certificate || null}
                                        required
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.EDUCATIONAL_CERTIFICATE}
                                        onChange={(event) => {
                                            handleTagChange('educational_certificate', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />

                                    {/* Valid Certificates Upload */}
                                    <FileUploader
                                        id="previous_certificates"
                                        name="previous_certificates"
                                        label="Kindly upload all your valid certificates."
                                        subTitle={`Do you have the minimum required professional qualification (e.g., Personal Trainer, Fitness Trainer, Strength & Conditioning Coach, Physiotherapist, Dance Instructor, Group Fitness Instructor, Pilates Instructor, Yoga Instructor, Nutrition Advisor, Wellness Coach, Health Coach, Gym Instructor, Sports Coach, Swimming Instructor, Aerobics Instructor, etc.) along with a valid CPR/AED Certification?`}
                                        accept='.pdf'
                                        uploadedImage={formData?.documents?.previous_certificates || null}
                                        required
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.PREVIOUS_CERTIFICATES_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('previous_certificates', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />
                                    <FileUploader
                                        id="digital_signature"
                                        name="digital_signature"
                                        label="Digital Signature (Type your full name as your digital signature)"
                                        accept='.png, .jpg, .jpeg'
                                        required
                                        uploadedImage={formData?.documents?.digital_signature || null}
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.DIGITAL_SIGNATURE_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('digital_signature', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />
                                </div>

                                <div className="space-y-4">
                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Services Offered :-
                                    </p>
                                    {
                                        formData.services.map((service, index) => (
                                            <div key={index} className="bg-[#22262E] border border-gray-600 p-4 rounded-lg space-y-4">
                                                <div className="flex justify-between items-center border-b border-gray-700 pb-2">
                                                    <h4 className="text-lg font-semibold text-white">Service {index + 1}</h4>
                                                    {
                                                        formData.services.length > 1 && (
                                                            <Button
                                                                type="button"
                                                                py="py-1"
                                                                px="px-5"
                                                                width="w-34"
                                                                disabled={isSubmitting}
                                                                onClick={() => removeService(index)}
                                                            >
                                                                Remove
                                                            </Button>
                                                        )
                                                    }
                                                </div>
                                                <FileUploader
                                                    id={`service-img-${index}`}
                                                    name={`service_img_${index}`}
                                                    label="Service Image"
                                                    required
                                                    uploadedImage={service.img || null}
                                                    maxFiles={1}
                                                    accept='.png, .jpg, .jpeg'
                                                    disabled={isSubmitting}
                                                    onChange={(e) => handleServiceChange(index, 'img_file', e.target.files)}
                                                />

                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    <Input
                                                        label="Service Title"
                                                        // subTitle='e.g., Personal Training'
                                                        id={`service-title-${index}`}
                                                        name={`service_title_${index}`}
                                                        value={service.title}
                                                        placeholder="Enter Your Service Title"
                                                        disabled={isSubmitting}
                                                        onChange={(e) => handleServiceChange(index, 'title', e.target.value)}
                                                    />
                                                    <Input
                                                        type="number"
                                                        label="Price (₹)"
                                                        id={`service-price-${index}`}
                                                        name={`service_price_${index}`}
                                                        value={service.price}
                                                        placeholder="e.g., 2999"
                                                        disabled={isSubmitting}
                                                        onChange={(e) => handleServiceChange(index, 'price', e.target.value)}
                                                        min="0"
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    }

                                    <Button
                                        type="button"
                                        width="w-full"
                                        onClick={addService}
                                        disabled={isSubmitting}
                                    >
                                        + Add Another Service
                                    </Button>
                                </div>

                                {/* Youtube Links */}
                                <div className="space-y-4">
                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Youtube Links :-
                                    </p>
                                    {
                                        formData.youtube_links.map((service, index) => (
                                            <div key={index} className="bg-[#22262E] border border-gray-600 p-4 rounded-lg space-y-4">
                                                <div className="flex justify-between items-center border-b border-gray-700 pb-2">
                                                    <h4 className="text-lg font-semibold text-white">Youtube Link {index + 1}</h4>
                                                    {
                                                        formData.youtube_links.length > 1 && (
                                                            <Button
                                                                type="button"
                                                                py="py-1"
                                                                px="px-5"
                                                                width="w-34"
                                                                disabled={isSubmitting}
                                                                onClick={() => { removeYoutubeLink(index) }}
                                                            >
                                                                Remove
                                                            </Button>
                                                        )
                                                    }
                                                </div>

                                                <Input
                                                    type='url'
                                                    label="Youtube Link"
                                                    // subTitle='e.g., Personal Training'
                                                    id={`youtube-url-${index}`}
                                                    name={`youtube_url_${index}`}
                                                    value={service.link}
                                                    placeholder="Enter Your Youtube Link"
                                                    disabled={isSubmitting}
                                                    onChange={(e) => { handleYoutubeChange(index, 'link', e.target.value) }}
                                                />

                                                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}
                                                <Input
                                                    label="Youtube Title"
                                                    id={`youtube-title-${index}`}
                                                    name={`youtube_title_${index}`}
                                                    value={service.title}
                                                    placeholder="Enter Your Youtube Title"
                                                    onChange={(e) => { handleYoutubeChange(index, 'title', e.target.value) }}
                                                    errorName={`youtube_links[${index}].title`}
                                                    errors={errors}
                                                />
                                                {/* <Input
                                                        type="number"
                                                        label="Youtube Video Viewer"
                                                        id={`youtube-views-${index}`}
                                                        name={`youtube_views_${index}`}
                                                        value={service.views}
                                                        placeholder="Enter Your Youtube Video Views"
                                                        disabled={isSubmitting}
                                                        onChange={(e) => { handleYoutubeChange(index, 'views', e.target.value) }}
                                                        min="0"
                                                    /> */}
                                                {/* </div> */}
                                            </div>
                                        ))
                                    }

                                    <Button
                                        type="button"
                                        width="w-full"
                                        disabled={isSubmitting}
                                        onClick={addYoutubeLink}
                                    >
                                        + Add Another Youtube Link
                                    </Button>
                                </div>
                                {
                                    !isMyProfilePage &&
                                    <>
                                        {/* FWPI Code of Ethics - Key Principles */}
                                        <div className="font-urbanist">
                                            <label className="block font-semibold mb-2 text-white">
                                                FWPI Code of Ethics – Key Principles
                                            </label>
                                            <ul className="list-decimal list-inside grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2 text-xs rounded-tr-sm rounded-2xl p-4 border border-white text-white">
                                                <li>Professional Competence</li>
                                                <li>Practice Within Scope</li>
                                                <li>Confidentiality & Data Protection</li>
                                                <li>Safety & Risk Management</li>
                                                <li>Effective Communication</li>
                                                <li>Commitment to Continued Learning</li>
                                                <li>Appearance & Hygiene</li>
                                                <li>Legal & Regulatory Compliance</li>
                                                <li>Honesty & Transparency</li>
                                                <li>Client-Centered Care</li>
                                                <li>Maintaining Professional Boundaries</li>
                                                <li>Respect for Cultural & Individual Diversity</li>
                                                <li>Ethical Marketing & Advertising</li>
                                                <li>Punctuality & Professional Conduct</li>
                                                <li>Conflict Resolution</li>
                                            </ul>
                                        </div>

                                        {/* Code of Ethics Declaration */}
                                        <Checkbox
                                            id="codeOfEthics"
                                            name="codeOfEthics"
                                            className='mt-0'
                                            label="I agree to uphold the FWPI Code of Ethics and pledge to maintain ethical, responsible, and professional conduct in all fitness and wellness practices."
                                            onChange={handleChange}
                                            errors={errors}
                                            checked={formData?.codeOfEthics}
                                            required
                                            disabled={isSubmitting}
                                        />
                                    </>
                                }

                                {/* Submit and Clear Buttons */}
                                <div className="flex justify-center gap-6 max-w-2xl mx-auto">
                                    <Button
                                        type="button"
                                        disabled={!isValidUserName || !formData?.codeOfEthics || isSubmitting}
                                        loading={isSubmitting}
                                        onClick={(e) => {
                                            handleSubmit(e)
                                        }}
                                    >
                                        Submit
                                    </Button>
                                    {
                                        !isMyProfilePage &&
                                        <Button
                                            type="reset"
                                            disabled={isSubmitting}
                                            onClick={(e) => {
                                                handleReset(e)
                                            }}
                                        >
                                            Clear Form
                                        </Button>
                                    }
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
export { CreateTrainer };
